module.exports = __webpack_public_path__ + "static/media/logo.1c530a15.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/Logo/logo.png
// module id = 223
// module chunks = 42